import fireAnalytics from '~/services/analytics/fireAnalytics';
import Butter from '~/typings/services/buttercms';

export const fireVisitedBlogHomepage = () =>
  fireAnalytics('Visited Blog Homepage');

export const fireVisitedBlogNavigation = (
  category?: Butter.Category | null,
  tag?: Butter.Tag | null,
) =>
  fireAnalytics('Visited Blog Navigation', null, {
    category: category?.name,
    tag: tag?.name,
  });

export const fireVisitedBlogPost = (post: Butter.Post) =>
  fireAnalytics('Visited Blog Post', null, {
    slug: post.slug,
    title: post.title,
  });

export const fireVisitedBlogSearch = (query: string) =>
  fireAnalytics('Visited Blog Search', null, { query });

export const fireVisitedBlogAuthor = (authorName: string) =>
  fireAnalytics('Visited Blog Author', null, { name: authorName });
